<template>
    <div
        class="media-image"
        :class="[
            {
                'media-image-plain': plainImage,
                'fill-height': fillHeight,
                'fill-width': fillWidth
            },
            autoResponsiveClass
        ]"
    >
        <img
            v-if="plainImage"
            :src="imgSrc"
            :srcset="imgSrcSet.join(',')"
            :alt="altText"
            :class="[
                {
                    'fill-height': fillHeight,
                    'fill-width': fillWidth,
                    'fluid-responsive-width': isFluidWidth,
                    'fluid-responsive-height': isFluidHeight
                },
                autoResponsiveClass,
                rounded
            ]"
            loading="lazy"
        />
        <v-img
            v-else
            :src="imgSrc"
            :srcset="imgSrcSet.join(',')"
            :alt="altText"
            :cover="!contain"
            :class="[
                {
                    'fill-height': fillHeight,
                    'fill-width': fillWidth
                },
                autoResponsiveClass
            ]"
            loading="lazy"
            :position="position"
            :rounded="rounded"
        />
    </div>
</template>

<script lang="ts" setup>
    import type {
        ContentImage,
        ContentImageSrcSet,
        RoundedValueCustom
    } from '~/types';
    import {
        useCdnResource
    } from 'x1-base/composables';
    import { isUndefined as lo_isUndefined } from 'es-toolkit';

    const props = withDefaults(
        defineProps<{
            data?: Nilish<ContentImage>;
            altText?: string;
            breakpoint?: string;
            autoResponsive?: boolean;
            fluidWidth?: boolean;
            fluidHeight?: boolean;
            plainImage?: boolean;
            contain?: boolean;
            fillHeight?: boolean;
            fillWidth?: boolean;
            position?: Undefinable<string>;
            rounded?: RoundedValueCustom;
        }>(),
        {
            altText: '',
            breakpoint: 'desktop',
            autoResponsive: true,
            plainImage: true,
            contain: true,
            fillHeight: true,
            fillWidth: true,
            position: undefined

        }
    );

    const imgSrc = ref<string>('');
    const imgSrcSet = ref<string[]>([]);
    const useCdnResourceObj = useCdnResource();

    props.data?.srcset?.forEach((srcObj: ContentImageSrcSet, i: number): void => {
        const url = srcObj.isCdn ? useCdnResourceObj.getResourceCdnUrl(srcObj.url) : srcObj.url;

        imgSrcSet.value.push(`${url} ${srcObj.size}`);

        // Set imgSrc to last item's value
        if (props.data && i === props.data.srcset.length - 1) {
            imgSrc.value = url;
        }
    });

    const autoResponsiveClass = computed<string>(() => {
        if (props.autoResponsive) {
            return props.breakpoint === 'desktop' ? 'responsive-full-height' : 'responsive-full-width';
        }

        return '';
    });

    const isFluidWidth = computed<boolean>(() => {
        if (lo_isUndefined(props.plainImage)) return false;
        return props.breakpoint === 'desktop' && props.fluidWidth;
    });

    const isFluidHeight = computed<boolean>(() => {
        if (lo_isUndefined(props.plainImage)) return false;
        return props.breakpoint === 'desktop' && props.fluidHeight;
    });
</script>

<style lang="scss"></style>
